export default "__VITE_ASSET__BtuZ5YMd__"